import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AdminThirtyEightyService {
    private _data: BehaviorSubject<string> = new BehaviorSubject(null);
    public get Data(): Observable<string> {
      return this._data.asObservable();
    }
    constructor() {
    }
    setEmplLastName(empLastName: string) {
      this._data.next(empLastName);
    }
  }